import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ffd235a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "conditions" }, "Conditions", -1))
const _hoisted_2 = {
  id: "conditions",
  class: "condition-list-box"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "12",
  y1: "8",
  x2: "12",
  y2: "16"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "8",
  y1: "12",
  x2: "16",
  y2: "12"
}, null, -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_TransitionGroup, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conditions, (condition, index) => {
            return (_openBlock(), _createElementBlock("button", {
              class: _normalizeClass(["condition-btn plain-text", [{'edit-mode': _ctx.editMode}, _ctx.determineGradient(index)]]),
              onClick: ($event: any) => (_ctx.click(index)),
              key: condition.name
            }, _toDisplayString(condition.name), 11, _hoisted_3))
          }), 128)),
          (!_ctx.editMode)
            ? (_openBlock(), _createElementBlock("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "40",
                height: "40",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "mediumpurple",
                "stroke-width": "3",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('new'))),
                class: "new-btn",
                key: "new-condition-btn"
              }, _hoisted_6))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ], 64))
}